/* eslint-disable camelcase */
import React, { useContext } from 'react'
import { useMergedState } from 'hooks'

const SubBarContext = React.createContext()

function SubBarProvider({ children }) {
  const [{ type, props, render }, setState] = useMergedState({
    type: `home`,
    props: null,
    render: null,
  })

  function setSubBar(newSubBar) {
    return setState(newSubBar)
  }

  return (
    <SubBarContext.Provider value={{ type, props, render, setSubBar }}>
      {children}
    </SubBarContext.Provider>
  )
}

function useSubBar() {
  const context = useContext(SubBarContext)
  if (!context) {
    throw new Error(`useSubBar must be used within a SubBarContext`)
  }
  return context
}

export { SubBarProvider, useSubBar }
